import { useTranslation } from 'react-i18next';

import { useRevokeUserSessions } from '@/admin/useRevokeUserSessions';

export interface RevokeSessionsButtonProps {
  /** Id local del usuario (`users.id`). */
  userId: number;
  name: string;
}

/** Botón «Cerrar sesiones» de un usuario, con confirmación y resultado en línea. */
export function RevokeSessionsButton({ userId, name }: RevokeSessionsButtonProps) {
  const { t } = useTranslation();
  const revoke = useRevokeUserSessions();

  return (
    <span className="inline-flex items-center gap-2">
      {revoke.isSuccess && revoke.data && (
        <span role="status" className="text-xs text-emerald-700">
          {t('roles.users.revokeSessionsDone', { count: revoke.data.revoked })}
        </span>
      )}
      {revoke.isError && (
        <span role="alert" className="text-xs text-rose-700">
          {t('roles.users.revokeSessionsError')}
        </span>
      )}
      <button
        type="button"
        aria-label={t('roles.users.revokeSessions', { name })}
        onClick={() => {
          if (confirm(t('roles.users.revokeSessionsConfirm', { name }))) {
            revoke.mutate(userId);
          }
        }}
        disabled={revoke.isPending}
        className="text-xs text-amber-700 hover:underline disabled:opacity-50"
      >
        {t('roles.users.revokeSessionsCta')}
      </button>
    </span>
  );
}
